import { useHistory } from "react-router-dom";
import { getMyLevels } from './helpers/CreateAdsHelper';
import CreateAdsRadioStep from './custom_views/CreateAdsRadioStep';
import { getUrlParameter } from "../../../utils/Utils";
import { useEffect } from 'react';
import { AdsApi } from "../../../api/AdsApi";

function CreateAdsStep4(props) {
    const history = useHistory()
    const id = getUrlParameter("id")
    const info = {
        progress : props.progress,
        pickedSpecs : props.pickedSpecs,
        header : "Уровень знаний<br/>в выбранной области",
        value : props.value,
        radioItems : getMyLevels()
    }
    useEffect(() => {
        const value = getUrlParameter("value")
        if (value != null && value != undefined && value != ""){
            props.setValue(getMyLevels()[value])
        }
    }, [])
    const onNext = () => {
        if (props.isEdit){
            AdsApi.editRequestRepetitor({repetitor_request_id : id, level_my : getMyLevels().indexOf(props.value)}, (response) => {
                window.location.href = '/ads_board/ads?id=' + id + "&is_details=true"
            })
            
        } else {
            history.push("/create_ads/step_5")
        }
    }
    return (
        <CreateAdsRadioStep isEdit={props.isEdit} info={info} onNext={onNext} setValue={props.setValue}/>
    );
}

export default CreateAdsStep4;
